<template>
  <div>
    <!-- lg and above  -->
    <v-app-bar
      app
      :color="$vuetify.theme.dark ? '#363636' : 'white'"
      elevation="0"
      height="70"
      class="d-inline"
      style="border-bottom: 1px solid rgba(15, 23, 42, 0.06);"
    >
      <v-layout column>
        <v-layout row class="px-6 mx-0">
          <vue-feather
            v-if="isAuthenticated && !$vuetify.breakpoint.lgAndUp"
            type="menu"
            class="text-secondary mt-2 hand-cursor"
            @click="toggleAppDrawer"
          />

          <img
            v-else-if="!$vuetify.breakpoint.lgAndUp"
            :src="
              $vuetify.theme.dark
                ? require('@/app/core-module/assets/images/LOGO_DARK_MODE.png')
                : require('@/app/core-module/assets/images/LOGO.png')
            "
            alt="Logo"
            height="40"
          />
          <bread-crumbs :items="crumbData" v-if="$vuetify.breakpoint.lgAndUp && isAuthenticated" />

          <!-- right side actions  -->
          <v-layout row class="align-self-center justify-end">
            <language-switcher v-if="$store.getters.isLocaleEnabled" />

            <v-icon
              v-if="!$vuetify.theme.dark"
              class="me-6"
              color="textLight"
              @click="toggleThemeMode"
            >
              mdi-weather-night
            </v-icon>

            <v-icon
              v-else
              class="me-6"
              color="textLight"
              @click="toggleThemeMode"
            >
              mdi-weather-sunny
            </v-icon>

            <currency-selector hidden />

            <profile-icon v-if="isAuthenticated" />
          </v-layout>
        </v-layout>
      </v-layout>
    </v-app-bar>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import ProfileIcon from "../../user-module/components/ProfileIcon";
import LanguageSwitcher from "./LanguageSwitcher";
import CurrencySelector from "./CurrencySelector";
import BreadCrumbs from "./BreadCrumbs.vue";

export default {
  components: {
    ProfileIcon,
    LanguageSwitcher,
    CurrencySelector,
    BreadCrumbs,
  },
  data() {
    return {
      crumbData: [
        {
          text: process.env.VUE_APP_SUBSCRIBER_NAME,
          disabled: false,
          href: "",
        },
        {
          text: "",
          disabled: true,
          href: "",
        },
      ],
    };
  },
  computed: {
    isAuthenticated() {
      return this.$store.state.isAuthenticated;
    },
  },
  watch: {
    "$route.name": {
      immediate: true,
      handler() {
        this.crumbData[1].text = this.$route.name;
      },
    },
  },
  methods: {
    ...mapActions(["toggleAppDrawer"]),
    toggleThemeMode() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;

      this.saveToLocalStorage(
        "ThemeMode",
        this.$vuetify.theme.dark ? "dark" : "light"
      );
    },
  },
};
</script>

<style scoped>
.fixed-right {
  position: fixed;
  right: 48px;
}
.fixed-center {
  position: fixed;
  left: 50%;
  transform: translate(-50%, 0);
}
>>> .v-toolbar__content {
  padding: 0 0 !important;
}
</style>
